module.exports = __webpack_public_path__ + "static/img/fwmk.a1dea40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/fwmk.png
// module id = pnG4
// module chunks = 171